import amerLogo from "../Assets/AmerEssaLogo.png";
import shadenLogo from "../Assets/shadenLogo.jpeg";
import muniraLogo from "../Assets/muniraLogo.jpeg";
import hasnaLogo from "../Assets/hasnaLogo.jpeg";
import mohammedLogo from "../Assets/mohammedLogo.jpeg";
export const APPLMembers = [
  {
    name: "Amer Alhelali",
    logo: amerLogo,
    description: "iOS developer, Software Engineer",
    linkedInURL: "https://linkedin.com/in/aamer-alhelaly",
    githubURL: "https://github.com/Aamer99",
    email: "aamer.alhelaly@gmail.com",
  },
  {
    name: "Shaden Aljaloud",
    logo: shadenLogo,
    description: "iOS developer, Software Engineer",
    linkedInURL: "https://linkedin.com/in/shaden-aljaloud-171592251",
    githubURL: "https://github.com/ShadenAl-jaloud",
    email: "shadenaljalood@gmail.com",
  },
  {
    name: "Munira Alhamdan",
    logo: muniraLogo,
    description: "iOS developer, Software Engineer",
    linkedInURL: "https://linkedin.com/in/munira-alhamdan",
    githubURL: "https://github.com/Munirabh",
    email: "Munira.b.hamdan@gmail.com",
  },
  {
    name: "Mohammed Alsaad",
    logo: mohammedLogo,
    description: "iOS developer, Software Engineer",
    linkedInURL: "https://linkedin.com/in/mohammed-alsaad-984abb239",
    githubURL: "https://github.com/Meem10",
    email: "Mohaalsaad.j@gmail.com",
  },
  {
    name: "Hasna Alsaqer",
    logo: hasnaLogo,
    description: "iOS developer, Software Engineer",
    linkedInURL: "https://linkedin.com/in/ha20s",
    githubURL: "https://github.com/ha20s",
    email: "hassna.ahmad98@gmail.com",
  },
];
